import React from "react";
import "./style.css";
import Typist from "react-typist";

const KvaliCodeWriter = () => {
  return (
    <code className="inner-code-writer">
      <Typist stdTypingDelay={2} avgTypingDelay={5} startDelay={200} cursor={{ blink: true, show: false }}>
        <div>
          <span className="const-color">"info"</span>
          <span className="obj-color">: </span>
          <span className="obj-color">&#123;</span>
        </div>
        <div>
          <div className="margin-left">
            <span className="key-color">"firstName"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">&#123;</span>
          </div>
          <div className="margin-left-medium">
            <div className="margin-left">
              <span className="key-color">"en"</span>
              <span className="obj-color">: </span>
              <span className="key-color">"FIRSTNAME"</span>
            </div>
            <div className="obj-color margin-left-sm">&#125;</div>
          </div>

          <div className="margin-left">
            <span className="key-color">"lastName"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">&#123;</span>
          </div>
          <div className="margin-left-medium">
            <div className="margin-left">
              <span className="key-color">"en"</span>
              <span className="obj-color">: </span>
              <span className="key-color">"LASTNAME"</span>
            </div>
          </div>
          <div className="obj-color margin-left">&#125;</div>
          <div className="margin-left">
            <span className="key-color">"birthDate"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"05-01-1995",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"expirationDate"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"10-03-28",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"sex"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"male",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"nationality"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"GEO",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"documentNumber"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"28IB38947",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"personalNumber"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"100010000",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"issueDate"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">"03.10.2018",</span>
          </div>
          <div className="margin-left">
            <span className="key-color">"verified"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">true</span>
          </div>
          <div>
            <span className="const-color">"events"</span>
            <span className="obj-color">: </span>
            <span className="obj-color">[</span>
          </div>
          <div className="margin-left">
            <p className="key-color">"LivenessPassed",</p>
            <p className="key-color">"DocumentPassed",</p>
            <p className="key-color">"SessionFinished"</p>
          </div>
          <div>
            <span className="obj-color">]</span>
            <span className="obj-color"></span>
            <span className="obj-color">&#125;</span>
          </div>
        </div>
      </Typist>
    </code>
  );
};

export default KvaliCodeWriter;
